'use strict';

export default class Profile {
	constructor() {
        (function($){
            if($('.profile-block').length > 0){
                var $mobile = $(window).outerWidth() < 769;

                $(".profile-slider").slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }).on('afterChange',function(){
                   
					var $current = $(".profile-slider .slick-active").data('slick-index') + 1;
                    if ($current < 10){ $current = "0" + $current; }

                    $('.num-holder .current').text($current);
                })
				
				setTimeout(function(){
					
					var $height = $(".profile-slider").height() - $(".profile-slider .field--name-field-image").height() + $(".profile-block .num-holder").height() + 10,
                    $num = - $height,
                    $pre = $height - 20;

                	//console.log($height);

					$('.profile-block .num-holder').css('top',$num);
					$('.profile-block .slick-prev, .profile-block .slick-next').css('bottom', $pre);
					
				},200)

                if ($mobile) {

                    var $total = $('.slick-slide').length - $('.slick-cloned').length;
                    var $current = $(".profile-slider .slick-active").data('slick-index') + 1;

                    if ($total < 10){ $total = "0" + $total; }
                    if ($current < 10){ $current = "0" + $current; }

                    $('.profile-block .num-holder .current').text($current);
                    $('.profile-block .num-holder .total').text($total);
                }
            }
        })(jQuery);
	}
}